export function resolveActiveStepFromKey(steps, stepKey, fallbackIndex = 0) {
  if (!stepKey) return fallbackIndex;

  const index = steps.findIndex((s) => s.key === stepKey);
  return index === -1 ? fallbackIndex : index;
}

function resolveActiveStep(steps, currentStep) {
  if (typeof currentStep !== 'number') return 0;
  if (currentStep < 0 || currentStep >= steps.length) return 0;
  return currentStep;
}

function deriveStepState(steps, activeStep, status) {
  return steps.map((step, idx) => ({
    ...step,
    completed: status === 'hired' ? true : idx < activeStep,
    disabled: idx > activeStep,
  }));
}

export function getStepState(steps, currentStep, status) {
  const activeStep = resolveActiveStep(steps, currentStep);
  return {
    activeStep,
    steps: deriveStepState(steps, activeStep, status),
  };
}

export function getStepIndexByKey(steps, key) {
  return steps.findIndex((s) => s.key === key);
}

export function normalizeOffers(rawOffers = []) {
  if (!Array.isArray(rawOffers)) return [];

  return rawOffers.filter(
    (offer) => offer?.offerLetter?.status !== null || offer?.offerLetter?.sendDate !== null,
  );
}

export function hasAcceptedOffer(round3 = []) {
  if (!Array.isArray(round3)) return false;

  return round3.some((entry) => entry?.offerLetter?.status === 'accepted');
}
